// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnimationsController from "./animations_controller"
application.register("animations", AnimationsController)

import ImageFallbackController from "./image_fallback_controller"
application.register("image-fallback", ImageFallbackController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RoleToggleController from "./role_toggle_controller"
application.register("role-toggle", RoleToggleController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import WrestlerSearchController from "./wrestler_search_controller"
application.register("wrestler-search", WrestlerSearchController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import ResponsiveController from "./responsive_controller"
application.register("responsive", ResponsiveController)

import StatsPriorityController from "./stats_priority_controller"
application.register("stats-priority", StatsPriorityController)

import TrainingScheduleController from "./training_schedule_controller"
application.register("training-schedule", TrainingScheduleController)

import SoundboardController from "./soundboard_controller"
application.register("soundboard", SoundboardController)

import SoundPreviewController from "./sound_preview_controller"
application.register("sound-preview", SoundPreviewController)

import CompTicketFormController from "./comp_ticket_form_controller"
application.register("comp-ticket-form", CompTicketFormController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import ReviewSliderController from "./review_slider_controller"
application.register("review-slider", ReviewSliderController)

import ReviewModalController from "./review_modal_controller"
application.register("review-modal", ReviewModalController)
